/* ngb modal as measured live: black .8 backdrop, centred dialog, 2px radius, no shadow. */
.backdrop {
  position: fixed;
  inset: 0;
  z-index: var(--cl-z-modal);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px 16px;
  overflow-y: auto;
  background: var(--cl-modal-backdrop-live);
}

.dialog {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: var(--cl-modal-width);
  max-height: 100%;
  margin: auto;
  border-radius: var(--cl-radius);
  background: var(--cl-modal-bg);
  color: var(--cl-text);
  outline: none;
}

.sm {
  max-width: var(--cl-modal-width);
}

.md {
  max-width: var(--cl-modal-width-md);
}

.lg {
  max-width: var(--cl-modal-width-lg);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 20px;
  border-bottom: 1px solid var(--cl-border-light);
}

.title {
  margin: 0;
  min-width: 0;
  color: var(--cl-modal-title);
  font-size: var(--cl-fs-2xl);
  font-weight: var(--cl-fw-regular);
  line-height: var(--cl-lh-base);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 25px;
  height: 25px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--cl-text-secondary);
  cursor: pointer;
}

.close:hover {
  color: var(--cl-text);
}

.close:focus-visible {
  outline: none;
  box-shadow: var(--cl-blue-focus-ring);
}

.form {
  display: contents;
}

.body {
  flex: 1;
  min-height: 0;
  padding: 20px;
  overflow-y: auto;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  padding: 12px 20px;
  border-top: 1px solid var(--cl-border-light);
}
